import { render, staticRenderFns } from "./galleries.vue?vue&type=template&id=5628f93c&"
import script from "./galleries.vue?vue&type=script&lang=js&"
export * from "./galleries.vue?vue&type=script&lang=js&"
import style0 from "./galleries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports